module.exports = __webpack_public_path__ + "img/LOGO-8.e8007894.png";